import http from '../libs/http'


export const getHome = (isFans) => {
  return http.get({uri: 'mall/homepage/', data: {isFans}});
};

export const getMallChannelListAPI = (isFans) => {
  return http.get({uri: 'mall/channel/list', data: {isFans}});
};

export const getMallChannelGoodsListAPI = (channel_id, index = 0) => {
  return http.get({
    uri: 'mall/channel/goods/list',
    data:{channel_id, index, limit: 20}
  });
};

///==========================  拉取商城搜索关键字 ⬇️ ============================
export const getMallSearchTagAPI = () => {
  return http.get({uri: 'mall/search/key/list'})
};
///========================== 拉取商城搜索关键字 ⤴️ ============================


/*
*   个人账户页信息
*   cartCount: 购物车数量数量
*   wxNum: 客服
*   membership: 0普通用户 1 普通会员 2超级会员
*   saveMoney: 超级会员省多少钱
 */
export const getAccountInfoAPI = () => {
  return http.get({uri:'mall/user/info'});
};


export const getCategories = (isFans) => {
  if (isFans)
    return http.get({uri: 'fans/category/'});
  return http.get({uri: 'categorypage/'});
};

export const getCateAPI = () => {
  return http.get({uri: 'mall/category/list'});
};

export const getCateInfoAPI = (_id) => {
  return http.get({uri: 'category/info', data: {_id}});
};


export const getCoupons = (noUsed = false, status = 0) => {
  if (noUsed) {
    return http.get({uri: 'user/coupon/noUsed'});
  }

  return http.get({uri: 'mall/user/coupon/list', data: {status}});

};

export const getProductDetail = (conditions) => {
  return http.get({uri: 'mall/commoditypage', data: conditions});

  return {
    isOk: true,
    code: 0,
    data: {
      relative: [],
      skus: [],
      select: {
        spu_id: "574862edba33dc5577af0299",
        _id: "59f05a2443fb6a33b2f6b824",
        title: "酷玩",
        specs: [
          {
            spec_id: "570e1175495b85f92539304e",
            specvalue_id: "59f05a1243fb6a33b2f6b822",
            specvalue_name: "好玩"
          },
          {
            spec_id: "5822dfcadd621d392474a495",
            specvalue_id: "59f05a1843fb6a33b2f6b823",
            specvalue_name: "大"
          }
        ],
        price: 20,
        stock: 100,
        pic: [
          "http://img.meizhanggui.cc/33464eb00840cdc40cc31be464ceca23"
        ],
        label: [],
        description: [],
        brand: "品牌2",
        supplier: "纹身大咖"
      },
      comments: [
        {
          _id: "5a1bf0d5841190058691e8f4",
          content: "好",
          userInfo: {
            nickname: "纹身大咖器材客服",
            _id: "57568cc6db86f3d53563730a"
          },
          sku: {
            specs: [
              {
                _id: "59f05a2443fb6a33b2f6b826",
                specvalue_name: "好玩",
                specvalue_id: "59f05a1243fb6a33b2f6b822",
                spec_name: "功能",
                spec_id: "570e1175495b85f92539304e"
              },
              {
                _id: "59f05a2443fb6a33b2f6b825",
                specvalue_name: "大",
                specvalue_id: "59f05a1843fb6a33b2f6b823",
                spec_name: "产品规格",
                spec_id: "5822dfcadd621d392474a495"
              }
            ],
            title: "酷玩",
            _id: "59f05a2443fb6a33b2f6b824"
          },
          pics: [
            "http://img.meizhanggui.cc/33464eb00840cdc40cc31be464ceca23",
            "http://img.meizhanggui.cc/33464eb00840cdc40cc31be464ceca23",
            "http://img.meizhanggui.cc/33464eb00840cdc40cc31be464ceca23",
            "http://img.meizhanggui.cc/33464eb00840cdc40cc31be464ceca23",
          ]
        },
        {
          _id: "5a1bf0d5841190058691e8f2",
          content: "好",
          userInfo: {
            nickname: "纹身大咖器材客服",
            _id: "57568cc6db86f3d53563730a"
          },
          sku: {
            specs: [
              {
                _id: "59f05a2443fb6a33b2f6b826",
                specvalue_name: "好玩",
                specvalue_id: "59f05a1243fb6a33b2f6b822",
                spec_name: "功能",
                spec_id: "570e1175495b85f92539304e"
              },
              {
                _id: "59f05a2443fb6a33b2f6b825",
                specvalue_name: "大",
                specvalue_id: "59f05a1843fb6a33b2f6b823",
                spec_name: "产品规格",
                spec_id: "5822dfcadd621d392474a495"
              }
            ],
            title: "酷玩",
            _id: "59f05a2443fb6a33b2f6b824"
          },
          pics: [
            "http://img.meizhanggui.cc/33464eb00840cdc40cc31be464ceca23"
          ]
        }
      ]
    }
  }
}


export const getProductComments = (spu_id) => {
  return http.get({uri: 'commodity/comment/list', data: {spu_id}})
}

export const getOrderDetail = (_id) => {
  return http.get({uri: 'mall/user/order/detail', data: {_id}})
}

// 超时未支付订单接口删除接口
export const deleteOrderAPI = (_id) => {
  return http.delete({uri: 'mall/user/order/cancel/remove', data: {_id}});
};

// 未支付未超时订单接口取消接口
export const cancelOrderAPI = (_id) => {
  return http.put({uri: 'mall/user/order/cancel', data: {_id}});
};


export const getOrders = (status) => {
  const data = {};
  if (status != null) {
    data['status'] = status
  }
  return http.get({uri: 'user/order', data})
  //   .then(res => {
  //   res.data.map(order => {
  //     order.status = 30;
  //     order.children.map(order => {
  //       order.status = 30;
  //       order.cancel = 0;
  //     })
  //   });
  //   return res
  // })
};


export const loginByUnionId = (unionId) => {
  return http.get({
    uri: 'wx/loginInfoByUnionId',
    data: {
      unionId
    },
  });
};

export const loginByCode = (code) => {
  return http.get({
    uri: 'wx/loginInfoByCode',
    data: {
      code
    },
  });
};

export const refreshLogin = () => {
  return http.get({uri: 'login'})
};


export const register = (phone, captcha, unionId) => {
  return http.post({
    uri: 'user/register',
    data: {
      phone,
      captcha,
      unionId
    }
  });
};


export const addCart = (sku_id, quantity) => {
  return http.post({
    uri: 'cart/add',
    data: {
      sku_id,
      quantity
    }
  });
};

export const cartBatchAddAPI = (data) => {
  return http.post({uri: 'cart/batch/add', data: data});
};

// 确认收货
export const postAffirmReceive = (_id) => {
  return http.post({uri: 'mall/user/order/received', data: {_id}});
};

export const editAddress = (data) => {
  return http.put({
    url: api + 'user/address',
    data
  })
};


export const addAddress = (data) => {
  return http.post({
    url: api + 'user/address',
    data
  })
};

/**
 * 首单红包
 */
export const getOrderWelfareAPI = () => {
  return http.get({uri: 'user/order/welfare'});
};



// WEBPACK FOOTER //
// ./src/api/common.js